import { MessageCircle, Mail } from "lucide-react";
import { CONTACT, waLink, mailLink } from "@/data/site";

/**
 * Inline WhatsApp + Email quick contact channels.
 * variant: "cards" (default) | "inline"
 */
export const ContactChannels = ({ variant = "cards", className = "" }) => {
  if (variant === "inline") {
    return (
      <div className={`flex flex-wrap gap-6 ${className}`}>
        <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="channel-whatsapp"
          className="flex items-center gap-2 text-sm font-semibold text-[hsl(var(--vc-ink))] hover:text-brand">
          <MessageCircle className="h-4 w-4 text-brand" /> {CONTACT.whatsappDisplay}
        </a>
        <a href={mailLink()} data-testid="channel-email"
          className="flex items-center gap-2 text-sm font-semibold text-[hsl(var(--vc-ink))] hover:text-brand">
          <Mail className="h-4 w-4 text-brand" /> {CONTACT.email}
        </a>
      </div>
    );
  }
  return (
    <div className={`grid gap-3 sm:grid-cols-2 ${className}`}>
      <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="channel-whatsapp"
        className="group flex items-center gap-3 rounded-xl border border-[hsl(var(--vc-line))] bg-white p-4 transition hover:border-brand hover:bg-mint">
        <span className="grid h-11 w-11 place-items-center rounded-lg bg-[#25D366]/12 text-[#1eaf54]">
          <MessageCircle className="h-5 w-5" />
        </span>
        <span className="flex flex-col">
          <span className="text-xs font-semibold uppercase tracking-wide text-[hsl(var(--vc-slate))]">WhatsApp</span>
          <span className="text-sm font-bold text-[hsl(var(--vc-ink))]">{CONTACT.whatsappDisplay}</span>
        </span>
      </a>
      <a href={mailLink()} data-testid="channel-email"
        className="group flex items-center gap-3 rounded-xl border border-[hsl(var(--vc-line))] bg-white p-4 transition hover:border-brand hover:bg-mint">
        <span className="grid h-11 w-11 place-items-center rounded-lg bg-mint text-brand">
          <Mail className="h-5 w-5" />
        </span>
        <span className="flex flex-col">
          <span className="text-xs font-semibold uppercase tracking-wide text-[hsl(var(--vc-slate))]">Email</span>
          <span className="text-sm font-bold text-[hsl(var(--vc-ink))]">{CONTACT.email}</span>
        </span>
      </a>
    </div>
  );
};

export default ContactChannels;
